import elbOverview from './overview.json';

import elbSummaryOperatingState from './widgets/elbSummaryOperatingState.json';
import elbSummaryHealth from './widgets/elbSummaryHealth.json';
import elbSummaryRegion from './widgets/elbSummaryRegion.json';
import elbSummaryType from './widgets/elbSummaryType.json';

import elbClassicRequests from './widgets/classic/requests/elbClassicRequests.json';
import elbClassicRequestsMaster from './widgets/classic/requests/elbClassicRequestsMaster.json';
import elbClassicRequestsDetail from './widgets/classic/requests/elbClassicRequestsDetail.json';
import elbClassicRequestsDetailTitle from './widgets/classic/requests/elbClassicRequestsDetailTitle.json';
import elbClassicRequestsHTTP from './widgets/classic/requests/elbClassicRequestsHTTP.json';
import elbClassicRequestsBackend from './widgets/classic/requests/elbClassicRequestsBackend.json';
import elbClassicRequestsSpillover from './widgets/classic/requests/elbClassicRequestsSpillover.json';

import elbClassicConnections from './widgets/classic/connections/elbClassicConnections.json';
import elbClassicConnectionsMaster from './widgets/classic/connections/elbClassicConnectionsMaster.json';
import elbClassicConnectionsDetail from './widgets/classic/connections/elbClassicConnectionsDetail.json';
import elbClassicConnectionsDetailTitle from './widgets/classic/connections/elbClassicConnectionsDetailTitle.json';
import elbClassicConnectionsTargetResponseTime from './widgets/classic/connections/elbClassicConnectionsTargetResponseTime.json';
import elbClassicConnectionsHostHealth from './widgets/classic/connections/elbClassicConnectionsHostHealth.json';
import elbClassicConnectionsProcessedBytes from './widgets/classic/connections/elbClassicConnectionsProcessedBytes.json';

import elbApplicationRequests from './widgets/application/requests/elbApplicationRequests.json';
import elbApplicationRequestsMaster from './widgets/application/requests/elbApplicationRequestsMaster.json';
import elbApplicationRequestsDetail from './widgets/application/requests/elbApplicationRequestsDetail.json';
import elbApplicationRequestsDetailTitle from './widgets/application/requests/elbApplicationRequestsDetailTitle.json';
import elbApplicationRequestsHttp from './widgets/application/requests/elbApplicationRequestsHttp.json';
import elbApplicationRequestsBackend from './widgets/application/requests/elbApplicationRequestsBackend.json';
import elbApplicationRequestsNonSticky from './widgets/application/requests/elbApplicationRequestsNonSticky.json';

import elbApplicationConnections from './widgets/application/connections/elbApplicationConnections.json';
import elbApplicationConnectionsMaster from './widgets/application/connections/elbApplicationConnectionsMaster.json';
import elbApplicationConnectionsDetail from './widgets/application/connections/elbApplicationConnectionsDetail.json';
import elbApplicationConnectionsDetailTitle from './widgets/application/connections/elbApplicationConnectionsDetailTitle.json';
import elbApplicationConnectionsTargetErrors from './widgets/application/connections/elbApplicationConnectionsTargetErrors.json';
import elbApplicationConnectionsConsumedLCUs from './widgets/application/connections/elbApplicationConnectionsConsumedLCUs.json';
import elbApplicationConnectionsFixedResponses from './widgets/application/connections/elbApplicationConnectionsFixedResponses.json';
import elbApplicationConnectionsHostHealth from './widgets/application/connections/elbApplicationConnectionsHostHealth.json';
import elbApplicationConnectionsProcessedBytes from './widgets/application/connections/elbApplicationConnectionsProcessedBytes.json';
import elbApplicationConnectionsTLSNegotiationErrors from './widgets/application/connections/elbApplicationConnectionsTLSNegotiationErrors.json';

import elbNetworkConnections from './widgets/network/connections/elbNetworkConnections.json';
import elbNetworkConnectionsMaster from './widgets/network/connections/elbNetworkConnectionsMaster.json';
import elbNetworkConnectionsDetail from './widgets/network/connections/elbNetworkConnectionsDetail.json';
import elbNetworkConnectionsDetailTitle from './widgets/network/connections/elbNetworkConnectionsDetailTitle.json';
import elbNetworkConnectionsTLSNegotiationErrors from './widgets/network/connections/elbNetworkConnectionsTLSNegotiationErrors.json';
import elbNetworkConnectionsHostHealth from './widgets/network/connections/elbNetworkConnectionsHostHealth.json';
import elbNetworkConnectionsConsumedLCUs from './widgets/network/connections/elbNetworkConnectionsConsumedLCUs.json';

import elbNetworkFlows from './widgets/network/flows/elbNetworkFlows.json';
import elbNetworkFlowsMaster from './widgets/network/flows/elbNetworkFlowsMaster.json';
import elbNetworkFlowsDetail from './widgets/network/flows/elbNetworkFlowsDetail.json';
import elbNetworkFlowsDetailTitle from './widgets/network/flows/elbNetworkFlowsDetailTitle.json';
import elbNetworkFlowsActive from './widgets/network/flows/elbNetworkFlowsActive.json';
import elbNetworkFlowsTCPResets from './widgets/network/flows/elbNetworkFlowsTCPResets.json';
import elbNetworkFlowsNew from './widgets/network/flows/elbNetworkFlowsNew.json';

import elbFilterOperatingState from './widgets/elbFilterOperatingState.json';
import elbFilterHealth from './widgets/elbFilterHealth.json';
import elbFilterRegion from './widgets/elbFilterRegion.json';
import elbFilterType from './widgets/elbFilterType.json';

export default [
  elbOverview,

  // Filters
  elbFilterOperatingState,
  elbFilterHealth,
  elbFilterRegion,
  elbFilterType,

  // Widgets

  // summary
  elbSummaryOperatingState,
  elbSummaryHealth,
  elbSummaryRegion,
  elbSummaryType,

  // classic metrics
  elbClassicRequests,
  elbClassicRequestsMaster,
  elbClassicRequestsDetail,
  elbClassicRequestsDetailTitle,
  elbClassicRequestsHTTP,
  elbClassicRequestsBackend,
  elbClassicRequestsSpillover,

  elbClassicConnections,
  elbClassicConnectionsMaster,
  elbClassicConnectionsDetail,
  elbClassicConnectionsDetailTitle,
  elbClassicConnectionsTargetResponseTime,
  elbClassicConnectionsHostHealth,
  elbClassicConnectionsProcessedBytes,

  // application metrics
  elbApplicationRequests,
  elbApplicationRequestsMaster,
  elbApplicationRequestsDetail,
  elbApplicationRequestsDetailTitle,
  elbApplicationRequestsHttp,
  elbApplicationRequestsBackend,
  elbApplicationRequestsNonSticky,

  elbApplicationConnections,
  elbApplicationConnectionsMaster,
  elbApplicationConnectionsDetail,
  elbApplicationConnectionsDetailTitle,
  elbApplicationConnectionsTargetErrors,
  elbApplicationConnectionsConsumedLCUs,
  elbApplicationConnectionsFixedResponses,
  elbApplicationConnectionsHostHealth,
  elbApplicationConnectionsProcessedBytes,
  elbApplicationConnectionsTLSNegotiationErrors,

  // network metrics
  elbNetworkConnections,
  elbNetworkConnectionsMaster,
  elbNetworkConnectionsDetail,
  elbNetworkConnectionsDetailTitle,
  elbNetworkConnectionsTLSNegotiationErrors,
  elbNetworkConnectionsHostHealth,
  elbNetworkConnectionsConsumedLCUs,

  elbNetworkFlows,
  elbNetworkFlowsMaster,
  elbNetworkFlowsDetail,
  elbNetworkFlowsDetailTitle,
  elbNetworkFlowsActive,
  elbNetworkFlowsTCPResets,
  elbNetworkFlowsNew,
];
